/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Blog_LedeInputs */

const en_marketing_blog_lede = /** @type {(inputs: Marketing_Blog_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture decisions, Cloudflare patterns, and what shipping on a typed foundation actually looks like.`)
};

const es_marketing_blog_lede = /** @type {(inputs: Marketing_Blog_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decisiones de arquitectura, patrones de Cloudflare y cómo es realmente lanzar sobre una base tipada.`)
};

const fr_marketing_blog_lede = /** @type {(inputs: Marketing_Blog_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décisions d'architecture, motifs Cloudflare et ce que livrer sur une fondation typée veut vraiment dire.`)
};

/**
* | output |
* | --- |
* | "Architecture decisions, Cloudflare patterns, and what shipping on a typed foundation actually looks like." |
*
* @param {Marketing_Blog_LedeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_blog_lede = /** @type {((inputs?: Marketing_Blog_LedeInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Blog_LedeInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_blog_lede(inputs)
	if (locale === "es") return es_marketing_blog_lede(inputs)
	return fr_marketing_blog_lede(inputs)
});